export default "__VITE_ASSET__DsLCnF$M__"